import React, { Component } from "react";
import Clock from "./Components/Clock/Clock";
import Title from "./Components/Titles/Titles";
import TextBlock from "./Components/TextBlock/TextBlock";
import Footer from "./Components/Footer/Footer";

import "./App.css";

import styled, { css } from "styled-components";

// import ReactAux from "./hoc/ReactAux/ReactAux";

const CountdownWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 0 0 0 2rem;

  @media (max-width: 1030px) {
    padding: 1rem;
  }

  ${props =>
    props.poppins &&
    css`
      font-family: "Poppins", sans-serif;
    `}
`;

const InformationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 0 2rem 0 0;

  @media (max-width: 1030px) {
    padding: 0;
  }

  ${props =>
    props.poppins &&
    css`
      font-family: "Poppins", sans-serif;
    `}
`;

const Body = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;

  ${props =>
    props.poppins &&
    css`
      font-family: "Poppins", sans-serif;
    `}
`;

class App extends Component {
  render() {
    return (
      <Body>
        <main className="main">
          <CountdownWrapper>
            <Title />
            <Clock />
          </CountdownWrapper>

          <InformationWrapper>
            <TextBlock />
          </InformationWrapper>
        </main>
        <Footer />
      </Body>
    );
  }
}

export default App;

/* <div className="image-explainer">
	<img
		src="../Year_2038_problem.gif"
		alt="year 2038 problem countdown explainer"
	/>
</div> */
